import React, { Component } from "react";
// import {MDBListGroup, MDBListGroupItem} from "mdbreact"
import Control from "react-leaflet-control";
import { Message } from "semantic-ui-react";
import axios from "axios";
import { Menu, Segment, Sidebar, Grid, Divider, Header, Icon, Button, Search,Popup } from "semantic-ui-react";
import { library } from "@fortawesome/fontawesome-svg-core";
import pagecontent from "../Helpers/IrrContent";
import AboutModal from "../../GeoportalModal";
import {
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import urls from "../../urls";
// import { Slider } from 'react-semantic-ui-range'
import TreeNode from "./TreeNodeV2";
import MapView from "./MapViewV2";
import Chart from "../../CChart_IRR";
import CheckBox from "./CheckBox";
import menus from "../Helpers/menus";
import file_ext from "../Helpers/file-heads";
import domain from "../../domain";
// import DateSlider from './DateSlider';
import colors from "../../colors";
// import NumberSlider from './DateSlider'
// import NumericInput from 'react-numeric-input';
import { FadeLoader } from "react-spinners";
import { Rnd } from "react-rnd";
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";

import PieChart from "./PieChart";
import ColumnChart from "./ColumnChart";
import FIRColumnChart from "./FIRColumnChart";
import RainfallChart from "./RainfallChart";
import IrrigationChart from "./IrrigationChart";
import RFIRCharts from './RF_IR_Graph';

import './table.css';
import IndexDiagram from '../assets/NPR_Index_diagram.png';
import pdf from '../assets/NHP_Irrigation_KBJNL_Weekly_Report_Rabi2022-23_20230324.pdf';
import pdfSeasonal from '../assets/NRSC_NHP_Irrigation_Report_Rabi_2021-22.pdf';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import color from "@material-ui/core/colors/amber";

library.add(
  faLayerGroup,
  faWindowClose,
  faChartBar,
  faAngleDoubleLeft,
  faAngleDoubleRight
);

var moment = require("moment");
var _ = require("lodash");

class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cropmapyears: null,
      cropmapseasons: null,
      cropyear: null,
      cropseason: null,
      commandAreaName:null,
      legend_array_overlay: {},
      arraycheck: [],
      swipevalue: 1,
      basinoverlays: [
        { id: 1, value: "Canal Network", layername: "canal_network_new", isChecked: false, info: false },
        { id: 2, value: "Command Area Boundary", layername: "narayanpur_command_boundary", isChecked: false, info: false },
        { id: 3, value: "Soil Map", layername: "nhp_soil_map_irrigation", isChecked: false, info: false },
        { id: 4, value: "Distributary Boundary", layername: "irrigation_distributary_boundaries", isChecked: false, info: true },
        // { id: 3, value: "LULC", isChecked: false },
        // {id: 4, value: "HO", isChecked: true},
        // {id: 5, value: "Village", isChecked: false,disabled:true}
      ],
      width: 420,
      height: 400,
      x: (window.innerWidth-270-800)/2,
      y: window.innerHeight - 650,
      modal: true,
      selectedMenu: null,
      // selectedMainMenu:"",
      // selectedMaps:null,
      // lastSelected:null,
      yearseasonEnabled: false,
      satellite: "sentinel2",
      studyarea: null,
      pointInfo: null,
      legend: null,
      selectedLayer: {},
      visible: true,
      // width:"100%",
      date: "",
      layerExist: true,
      wms_url: `${domain.Geoserver}/nhp_irrigation/wms`,
      chartloading: true,
      latlng: { lat: null, lng: null },
      visibleGraphPanel: true,
      availableDates: [],
      selectedNodeStaus: {},
      slideTracker: -1,
      chartData: null,
      onClickDetails: {},
      stateInfo: null,
      dateEnabled: false,
      toggleActive: true,
      technicalnoteenable: false,
      disclaimerenable: false,
      IndexDiagramEnable: false,

      year: "2019",
      season: "kharif",
      // defaultDate:''
      // isDialogOpen: false


      viewport:  {
        zoom: 8,
        center: [25.12539, 80.00164],
      },

      cwsi_stats: [],
      // cwsi_stats: [29.62, 68.38, 2.0],
      cwsi_pie_categories: ["Good", "Satisfactory", "Poor"],

      ca_areas: [],
      selectedCommandArea: 'NIS',

      cap_stats_date: [],
      cap_stats_paddy: [],
      cap_stats_bi: [],
      cap_stats_id: [],
      cap_stats_per: [],

      ir_data: [],
      rf_data: [],
      forecastdays: 0,
      selection_min: 0,
      selection_max: 0,

      distributary_details: {},
      distributary_details_visibility: false,

      // hist_ca_data_rabi: [{"basin":"IBC","irridated_dry":"3985","paddy":"13879","biseasonal":"16789","perinnial":"65541","total":"100194","season":"Rabi"},{"basin":"JBC","irridated_dry":"2568","paddy":"15784","biseasonal":"18618","perinnial":"23142","total":"60112","season":"Rabi"},{"basin":"MBC","irridated_dry":"1259","paddy":"23981","biseasonal":"18614","perinnial":"7395","total":"51249","season":"Rabi"},{"basin":"NLBC","irridated_dry":"18294","paddy":"8974","biseasonal":"8741","perinnial":"8169","total":"44178","season":"Rabi"},{"basin":"SBC","irridated_dry":"18795","paddy":"18875","biseasonal":"21054","perinnial":"10789","total":"69513","season":"Rabi"},{"basin":"Total Command ","irridated_dry":"44901","paddy":"81493","biseasonal":"83816","perinnial":"115036","total":"325246","season":"Rabi"}],
      // hist_ca_data_kharif: [{"basin":"IBC","irridated_dry":"4436.401452","paddy":"28160.96576","biseasonal":"45524.08986","perinnial":"12177.05195","total":"90298.50902","season":"Kharif"},{"basin":"JBC","irridated_dry":"3973.2364","paddy":"11294.12014","biseasonal":"21888.42717","perinnial":"2186.803045","total":"39342.58676","season":"Kharif"},{"basin":"MBC","irridated_dry":"1595.701936","paddy":"9793.923291","biseasonal":"25289.34436","perinnial":"956.3580716","total":"37635.32766","season":"Kharif"},{"basin":"NLBC","irridated_dry":"25263.41111","paddy":"6798.710468","biseasonal":"9537.887772","perinnial":"1972.637509","total":"43572.64686","season":"Kharif"},{"basin":"SBC","irridated_dry":"23509.11076","paddy":"23090.19947","biseasonal":"56828.62943","perinnial":"4935.967244","total":"108363.9069","season":"Kharif"},{"basin":"Total Command ","irridated_dry":"58777.86166","paddy":"79137.91913","biseasonal":"159068.3786","perinnial":"22228.81782","total":"319212.9772","season":"Kharif"}],

      // hist_gir_data_rabi: [{"basin":"IBC","january":"15.72","february":"17.87","march":"12.14","april":"8.64","total":"54.37"},{"basin":"JBC","january":"5.11","february":"8.48","march":"3.86","april":"2.15","total":"19.6"},{"basin":"MBC","january":"11.27","february":"5.92","march":"3.12","april":"2.24","total":"22.55"},{"basin":"NLBC","january":"3.55","february":"11.83","march":"7.27","april":"4.51","total":"27.16"},{"basin":"SBC","january":"8.21","february":"13.29","march":"9.68","april":"5.87","total":"37.05"},{"basin":"Total Command ","january":"43.86","february":"57.39","march":"36.07","april":"23.41","total":"160.73"}],
      // hist_gir_data_kharif: [{"basin":"IBC","july":"4.26","aug":"6.18","sep":"7.62","oct":"6.56","total":"24.62"},{"basin":"JBC","july":"0.45","aug":"0.91","sep":"1.12","oct":"0.87","total":"3.35"},{"basin":"MBC","july":"0.5","aug":"0.41","sep":"0.4","oct":"0.21","total":"1.52"},{"basin":"NLBC","july":"2.74","aug":"6.52","sep":"6.38","oct":"3","total":"18.64"},{"basin":"SBC","july":"2.48","aug":"5.38","sep":"4.92","oct":"2.7","total":"15.48"},{"basin":"Total Command ","july":"10.43","aug":"19.4","sep":"20.44","oct":"13.34","total":"63.61"}],

      // hist_cwsi_data_rabi: [{"basin":"IBC","poor":"3600.89","average":"35619.47","good":"15988.49"},{"basin":"JBC","poor":"1555.23","average":"16444.8","good":"5311.38"},{"basin":"MBC","poor":"1191.46","average":"20051.27","good":"4179.15"},{"basin":"NLBC","poor":"318.19","average":"4009.34","good":"1464.43"},{"basin":"SBC","poor":"997.91","average":"17594.68","good":"5477.01"},{"basin":"Total Command ","poor":"7663.68","average":"93719.56","good":"32420.46"}],
      // hist_cwsi_data_kharif: [{"basin":"IBC","poor":"3600.89","average":"35619.47","good":"15988.49"},{"basin":"JBC","poor":"1555.23","average":"16444.8","good":"5311.38"},{"basin":"MBC","poor":"1191.46","average":"20051.27","good":"4179.15"},{"basin":"NLBC","poor":"318.19","average":"4009.34","good":"1464.43"},{"basin":"SBC","poor":"997.91","average":"17594.68","good":"5477.01"},{"basin":"Total Command ","poor":"7663.68","average":"93719.56","good":"32420.46"}],
      
      layers: urls.map_layer,
      url: urls.bhuvan_map,
      baselayerselected: "Map",

      cropAreaLayer: null,
      cropAreaDate: null,
      cwismLayer: null,
      cwismDate: null,
      cropAreaName:null,

      caHistYears: [],
      girHistYears: [],
      cwsimHistYears: [],

      // caHistSeasons: null,
      // girHistSeasons: null,
      // cwsimHistSeasons: null,

      hist_years:[],
      hist_selectedyear: '#',
      hist_cropmapseasons: [],
      // hist_cropmapseasons: ['Rabi', 'Kharif'],
      hist_cropseason: null,

      hist_selectedLayer: null,

      caHistStats: [],
      girHistStats: [],
      cwsiHistStats: [],
      cwsiHistStats1: [],

      opticalSensors: [],
      opticalYears: [],
      opticalSeasons: [],
      opticalDates: [],

      mwSensors: [],
      mwYears: [],
      mwSeasons: [],
      mwDates: [],

      selectedOpticalSensor: "#",
      selectedOpticalYear: "#",
      selectedOpticalSeason: "#",
      selectedOpticalDate: "#",

      selectedMWSensor: "#",
      selectedMWYear: "#",
      selectedMWSeason: "#",
      selectedMWDate: "#",
      irrigation_req_details:[],
      irr_req_startdate:"",
      irr_req_enddate:"",


      selectedSatelliteLayer: null,
    };

    this.makeChartDataAvailableDays = this.makeChartDataAvailableDays.bind(
      this
    );
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
  }


  getSensors = (selectedMenu) => {

    if(selectedMenu === 'Satellite Imagery-Optical' && this.state.opticalSensors.length !== 0) return; 
    if(selectedMenu === 'Satellite Imagery-Microwave' && this.state.mwSensors.length !== 0) return; 

    let url = '';

    if(selectedMenu === 'Satellite Imagery-Optical') url = `${domain.DBServer}/fetch-sensor-satellite/optical`;
    if(selectedMenu === 'Satellite Imagery-Microwave') url = `${domain.DBServer}/fetch-sensor-satellite/microwave`;

    if (url === '') return;

    axios.get(url).then((result) => {
      if (result) {
        console.log('Sat 123', result.data);

        if(result.data.length === 0) return;

        if(selectedMenu === 'Satellite Imagery-Optical') {
          this.setState({
            opticalSensors: result.data,
          });
        }

        if(selectedMenu === 'Satellite Imagery-Microwave') {
          this.setState({
            mwSensors: result.data,
          });
        }       
      }
    });

  }

  getSensorYears = (sensor, selectedMenu) => {

    let url = '';

    if(selectedMenu === 'Satellite Imagery-Optical') url = `${domain.DBServer}/fetch-sensor-year/optical/${sensor}`;
    if(selectedMenu === 'Satellite Imagery-Microwave') url = `${domain.DBServer}/fetch-sensor-year/microwave/${sensor}`;

    if (url === '') return;

    axios.get(url).then((result) => {
      if (result) {
        console.log('Sat 123', result.data);

        if(result.data.length === 0) return;

        if(selectedMenu === 'Satellite Imagery-Optical') {
          this.setState({
            opticalYears: result.data,
          });
        }

        if(selectedMenu === 'Satellite Imagery-Microwave') {
          this.setState({
            mwYears: result.data,
          });
        }       
      }
    });

  }

  getSensorYearSeasons = (newValue, selectedMenu) => {

    let url = '';

    if(selectedMenu === 'Satellite Imagery-Optical') url = `${domain.DBServer}/fetch-sensor-season/optical/${this.state.selectedOpticalSensor}/${newValue}`;
    if(selectedMenu === 'Satellite Imagery-Microwave') url = `${domain.DBServer}/fetch-sensor-season/microwave/${this.state.selectedMWSensor}/${newValue}`;

    if (url === '') return;

    axios.get(url).then((result) => {
      if (result) {
        console.log('Sat 123', result.data);

        if(result.data.length === 0) return;

        if(selectedMenu === 'Satellite Imagery-Optical') {
          this.setState({
            opticalSeasons: result.data,
          });
        }

        if(selectedMenu === 'Satellite Imagery-Microwave') {
          this.setState({
            mwSeasons: result.data,
          });
        }       
      }
    });

  }

  getSensorYearSeasonDates = (newValue, selectedMenu) => {

    let url = '';

    if(selectedMenu === 'Satellite Imagery-Optical') url = `${domain.DBServer}/fetch-sensor-date-layer/optical/${this.state.selectedOpticalSensor}/${this.state.selectedOpticalYear}/${newValue}`;
    if(selectedMenu === 'Satellite Imagery-Microwave') url = `${domain.DBServer}/fetch-sensor-date-layer/microwave/${this.state.selectedMWSensor}/${this.state.selectedMWYear}/${newValue}`;

    if (url === '') return;

    console.log('Sat 1234', url);

    axios.get(url).then((result) => {
      if (result) {
        console.log('Sat 1234', result.data);

        if(result.data.length === 0) return;

        if(selectedMenu === 'Satellite Imagery-Optical') {
          this.setState({
            opticalDates: result.data,
          });
        }

        if(selectedMenu === 'Satellite Imagery-Microwave') {
          this.setState({
            mwDates: result.data,
          });
        }       
      }
    });

  }

  setSelectionMinMax = (min, max) => {
    this.setState({
      selection_min: min,
      selection_max: max,
    });
  };

  //New version

  changeBaseLayer = (value) => {
    let layers, url;
    //  this.findActiveLayers()
    // console.log(event.target);
    if (value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (value === "Satellite") {
      layers = urls.s_layer;
      url = urls.satellite;
    } else if (value === "Command Area") {
      layers = "nhp_irrigation%:India Command Area";
      url = `${domain.Geoserver}/nhp_irrigation/wms`;
    }

    this.setState({
      baselayerselected: value,
      url: url,
      layers: layers,
    });
  };

  



  handleMapClick = (latlng) => {
    let url = `${domain.DBServer}/fetch-irrigation-distributary-nar/${latlng.lng}/${latlng.lat}`

    axios.get(url).then((result) => {
      if (result) {
        console.log('CAD MP 1', result.data);

        if(result.data.length === 0) return;

        this.setState({
          distributary_details: result.data[0],
          distributary_details_visibility: true,
        });

      }
    });
  }

  getIrrigationCommand = () => {
    if(this.state.ca_areas.length === 0) {
      axios.get(`${domain.DBServer}/fetch-irrigation-command-nar`).then((result) => {
        if (result) {
          console.log('CA 123', result);
          this.setState({
            ca_areas: result.data,
          });
        }
      });
    }
  }

  doCommandAreaChange = (newValue) => {
    console.log(newValue);
    this.setState({
      selectedCommandArea: newValue,
      distributary_details_visibility: false,
    });
    this.getCommandAreaDetails(newValue);

    let test = (this.state.selectedMenu === 'Historical Season-Crop Map Historic') ? 'ca': (this.state.selectedMenu === 'Historical Season-Irrigation Requirement') ? 'gir' : (this.state.selectedMenu === 'Historical Season-Irrigation System Performance') ? 'cwsi' : null;

    if (!this.state.hist_cropseason) return;

    if (test) this.getHistoricStats(newValue, this.state.hist_selectedyear, this.state.hist_cropseason, test);

  };


  // getIrrigationGIR = (commandArea) => {
  //   let url;
  //   if (commandArea === 'NIS') {
  //     url = `${domain.DBServer}/fetch-irrigation-gir`
  //   } else {
  //     url = `${domain.DBServer}/fetch-irrigation-gir-branch/${commandArea}`
  //   }
  //   axios.get(url).then((result) => {
  //     if (result) {
  //       console.log('CAD gir', result.data);

  //       const ir_data = result.data.map(x => {
  //         return [new Date(x.date).getTime(), x.gir];
  //       });

  //       const rf_data = result.data.map(x => {
  //         return [new Date(x.date).getTime(), x.rain];
  //       });

  //       const forecastdays = result.data.reduce((previousValue, x) => {
  //         return (x.mode === 'FR') ?  previousValue+1 : previousValue
  //       }, 0);

  //       const ir_data1 = ir_data.sort(function(a, b) {
  //         return a[0] - b[0];
  //       });

  //       const rf_data1 = rf_data.sort(function(a, b) {
  //         return a[0] - b[0];
  //       });

  //       // console.log('CAD gir 1', ir_data1);
  //       // console.log('CAD gir 2', rf_data1);
  //       // console.log('CAD gir 3', forecastdays);
  //       // console.log('CAD gir 4', ir_data1[ir_data1.length-1][0]);
  //       // console.log('CAD gir 5', ir_data1[ir_data1.length-14][0]);

  //       this.setState({
  //         ir_data: ir_data1,
  //         rf_data: rf_data1,
  //         forecastdays: forecastdays,
  //         selection_max: ir_data1[ir_data1.length-1][0], 
  //         selection_min: ir_data1[ir_data1.length-14][0], 
  //       });

  //     }
  //   }); 
  // }


  // getIrrigationCWSI = (commandArea) => {
  //   let url;
  //   if (commandArea === 'NIS') {
  //     url = `${domain.DBServer}/fetch-irrigation-cwsi`
  //   } else {
  //     url = `${domain.DBServer}/fetch-irrigation-cwsi-branch/${commandArea}`
  //   }
  //   axios.get(url).then((result) => {
  //     if (result) {
  //       console.log('CAD cwsi 1', result.data);

  //       let stats = [];
  //       var data = result.data;

  //       stats.push(parseFloat(data[2].good));
  //       stats.push(parseFloat(data[2].average));
  //       stats.push(parseFloat(data[2].poor));

  //       this.setState({
  //         cwsi_stats: stats,
  //       });

  //     }
  //   }); 
  // }

  // getIrrigationCA = (commandArea) => {
  //   let url;
  //   if (commandArea === 'NIS') {
  //     url = `${domain.DBServer}/fetch-irrigation-ca`
  //   } else {
  //     url = `${domain.DBServer}/fetch-irrigation-ca-branch/${commandArea}`
  //   }
  //   axios.get(url).then((result) => {
  //     if (result) {
  //       console.log('CAD ca', result.data);

  //       const paddy = result.data.map(x => parseFloat(x.paddy) );

  //       const bi = result.data.map(x => parseFloat(x.biseasonal) );

  //       const id = result.data.map(x => parseFloat(x.irridated_dry) );

  //       const perinnial = result.data.map(x => parseFloat(x.perinnial) );

  //       const date = result.data.map(x => {
  //         let arr = x.date.split("-");

  //         return `${arr[1]}/${arr[2]}/${arr[0]} GMT`;
  //       });

  //       // console.log('CAD ca 1', paddy);
  //       // console.log('CAD ca 1', bi);
  //       // console.log('CAD ca 1', id);
  //       // console.log('CAD ca 1', perinnial);
  //       // console.log('CAD ca 1', date);

  //       this.setState({
  //         cap_stats_bi: bi,
  //         cap_stats_date: date,
  //         cap_stats_id: id,
  //         cap_stats_paddy: paddy,
  //         cap_stats_per: perinnial,
  //       });


  //     }
  //   }); 
  // }

  getIrrigationDeatils = (commandArea) => {
    let url;
    if (commandArea === 'NIS') {
      url = `${domain.DBServer}/fetch-irrigation-all`
    } else {
      url = `${domain.DBServer}/fetch-irrigation-branch-all/${commandArea}`
    }

    axios.get(url).then((result) => {
      console.log('Test 123 a', result);
      if (result) {
        console.log('Test 123 a', result.data);
        let currentSeasonStats = result.data;


        if(currentSeasonStats[0].data !== null) {
          let stats = [];
          let cwsiData = currentSeasonStats[0].data[0];

          // console.log('Test 123 cwsi', cwsiData);

          stats.push(parseFloat(cwsiData.good));
          stats.push(parseFloat(cwsiData.average));
          stats.push(parseFloat(cwsiData.poor));

          this.setState({
            cwsi_stats: stats,
          });
        } else {
          this.setState({
            cwsi_stats: [],
          })

        }

        if(currentSeasonStats[1].data !== null) {
          let capData = currentSeasonStats[1].data;
          console.log('Test 123 cap', capData);

          capData.sort(function(a, b){return Number(a.date.replaceAll('-', ''))-Number(b.date.replaceAll('-', ''))});

          const paddy = capData.map(x => (parseFloat(x.paddy)).toFixed(2) );

          const bi = capData.map(x => (parseFloat(x.biseasonal)).toFixed(2) );

          const id = capData.map(x => (parseFloat(x.irridated_dry)).toFixed(2) );

          const perinnial = capData.map(x => (parseFloat(x.perinnial)).toFixed(2) );

          const date = capData.map(x => {
            let arr = x.date.split("-");

            return x.date;
            // return `${arr[1]}/${arr[2]}/${arr[0]} GMT`;
          });

          this.setState({
            cap_stats_bi: bi,
            cap_stats_date: date,
            cap_stats_id: id,
            cap_stats_paddy: paddy,
            cap_stats_per: perinnial,
          });
        } else {
          this.setState({
            cap_stats_date: [],
            cap_stats_paddy: [],
            cap_stats_bi: [],
            cap_stats_id: [],
            cap_stats_per: [],
          });

        }

        if(currentSeasonStats[2].data !== null) {
          //array.map((x) => { return parseFloat(x.toFixed(2)) })
          let girData = currentSeasonStats[2].data;
           console.log('Test 123 gir', girData);

          const ir_data = girData.map(x => {
            return [new Date(x.date).getTime(), x.gir];
          });
  
          const rf_data = girData.map(x => {
            return [new Date(x.date).getTime(), x.rain];
          });

          console.log('NIS FR1b', ir_data);
          console.log('NIS FR2b', rf_data);
  
          const forecastdays = girData.reduce((previousValue, x) => {
            return (x.mode === 'FR') ?  previousValue+1 : previousValue
          }, 0);

          // const forecastdays = 15;

          console.log('NIS FR', forecastdays);
  
          const ir_data1 = ir_data.sort(function(a, b) {
            return a[0] - b[0];
          });

          console.log('NIS FR1', ir_data1);
  
          const rf_data1 = rf_data.sort(function(a, b) {
            return a[0] - b[0];
          });

          console.log('NIS FR2', rf_data1);
  
          this.setState({
            ir_data: ir_data1,
            rf_data: rf_data1,
            forecastdays: forecastdays,
            selection_max: ir_data1[ir_data1.length-1][0], 
            selection_min: ir_data1[ir_data1.length-(forecastdays + 7)][0], 
          });

          
        } else {
          
          this.setState({
            ir_data: [],
            rf_data: [],
            forecastdays: 0,
            selection_min: 0,
            selection_max: 0,
          })
        }


      }
    });

  }

  getCommandAreaDetails = (commandArea) => {
    this.getBaseLayer(commandArea);
    // this.getIrrigationCA(commandArea);
    // this.getIrrigationCWSI(commandArea);
    // this.getIrrigationGIR(commandArea);
    this.getIrrigationDeatils(commandArea);
    
  }

  getIrrigationRequirements=()=>{

    axios.get(`${domain.DBServer}/fetch-irrigation-requirements`).then((result) => {
      console.log('result of irrigation requirements', result);
      if (result) {
        
        console.log('Test 123 a', result.data);
        let strtdate=result.data[0].from_date;
        let enddate=result.data[0].to_date;
        let year1,month1,day1,enddate1;

        if(enddate!==null){
           [year1, month1, day1] = enddate.split("-");
          enddate1 = `${day1}-${month1}-${year1}`;


        }
        else {
          enddate1="till date"
        }
        let [year, month, day] = strtdate.split("-");
        let strtdate1 = `${day}-${month}-${year}`;

        this.setState({
          irrigation_req_details:result.data[0],
          irr_req_startdate:strtdate1,
          irr_req_enddate:enddate1,

        })
      }
      console.log("reqqqqqqqq of irri",this.state.irrigation_req_details)
    })

  }



  onToggle = () => {
    this.setState({ toggleActive: !this.state.toggleActive });
  };

  toggleVisibleGraphPanel = () => {
    this.setState({
      visibleGraphPanel: !this.state.visibleGraphPanel,
      technicalnoteenable: false,
      disclaimerenable: false,
      IndexDiagramEnable: false,
    });
  };

  handleVisibleGraphPanelOnMapClick = () => {
    this.setState({
      visibleGraphPanel: true,
    });
  };

  toggleSelectedNodeStatus = (menu) => {
    let selectedNodeStaus = { ...this.state.selectedNodeStatus };
    selectedNodeStaus[menu] = !selectedNodeStaus[menu];

    this.setState({
      selectedNodeStaus: selectedNodeStaus,
    });
  };

  enableDatePicker = (status) => {
    this.setState({
      dateEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  enableYearSeason = (status) => {
    this.setState({
      yearseasonEnabled: status,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  handleAnimationChange = () => {
    this.setState({
      visible: !this.state.visible,
      // width: !this.state.visible?"76.5%":"100%"
    });
  };

  setSelectedMenu = (menu) => {
    this.setState({
      selectedMenu: menu,
      hist_selectedLayer: null,
      hist_cropseason: null,
      selectedSatelliteLayer: null,
      selectedOpticalSeason: null,
      selectedOpticalDate: null,
      selectedMWSeason: null,
      selectedMWDate: null,
      // lastSelected: menu
    });
    console.log(menu);
    if (menu === "Satellite Imagery-Optical") {
      this.setState({
        satellite: "sentinel2",
        season: "kharif",
        year: "2020",
      });
    } else if (menu === "Satellite Imagery-Microwave") {
      this.setState({
        satellite: "sentinel1",
        season: "kharif",
        year: "2020",
      });
    } else if (menu === "Crop Map") {
      this.setState({
        satellite: "sentinel2",
        season: "kharif",
        year: "2020",
      });
    } else if (menu.split("-")[0] === "Crop Water Demand") {
      console.log(menu);
      this.getAvailableDates(menu.split("-")[1]);
      this.setState({
        satellite: "sentinel2",
        season: "kharif",
        year: "2020",
      });
    }
    this.setState({
      //   latlng:null,
      visibleGraphPanel: false,
    });
  };

  async getAvailableDates(value) {
    // let availableDates = [...this.state.availableDates]
    // let availableDates=[]
    // console.log(availableDates)
    // console.log(value);

    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates/${value}`,
    });
    // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
    if (result) {
      if (result.data) {
        console.log(result.data);
        const availableDates = result.data.map((item) => {
          var date = item.filename.match(/\d{4}\d{2}\d{2}/g)[0];

          console.log(date);
          // availableDates.push(moment(date))
          return moment(date);
        });
        //    console.log(ad)
        console.log(availableDates);
        // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
        let maxdate = moment.max(availableDates);
        console.log(maxdate);
        let sortedDates = _.sortBy(availableDates, (d) => {
          // console.log(d)
          return new moment(d);
        });
        console.log(sortedDates);
        this.setState({
          availableDates: sortedDates,
          date: maxdate,
          slideTracker: sortedDates.length - 1,
          // selectedLayer:selectedLayer,
        });
      }
    }
    // let sortedDates = availableDates.sort(function (left, right) {
    //     return moment.utc(left.timeStamp).diff(moment.utc(right.timeStamp))
    // });
  }

  setSelectedLayer = (main) => {
    console.log(main);
    let selectedLayer = { ...this.state.selectedLayer };
    if (main) {
      if (main.split("-")[0] === "Base Layers") {
        selectedLayer[main] = main.split("-")[1];
      } else if (main.split("-")[0] === "Crop Water Demand") {
        selectedLayer[main] = moment.isMoment(this.state.date)
          ? file_ext[main] + "_" + this.state.date.format("YYYYMMDD")
          : file_ext[main] +
          "_" +
          moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");

        // selectedLayer[main]=file_ext[main]+"_"+moment(this.state.date,"DD-MM-YYYY").format("YYYYMMDD")
      } else if(main==='Crop Map')
       {
        selectedLayer[main] =
          file_ext[main] +
          "_" +
          this.state.satellite +
          "_" +
          this.state.cropyear +
          "_" +
          this.state.cropseason;
      }
      else
      {
        {
          selectedLayer[main] =
            file_ext[main] +
            "_" +
            this.state.satellite +
            "_" +
            this.state.year +
            "_" +
            this.state.season;
        }
      }
    }
    //   selectedLayer[main]=moment.isMoment(this.state.date)?file_heads[main]+this.state.date.format("YYYYMMDD"):file_heads[main]+moment(this.state.date,"DD-MM-YYYY").format("YYYYMMDD")
    if (selectedLayer !== undefined)
      // }

      this.setState({
        selectedLayer: selectedLayer,
        // selectedMaps:selectedMaps
      });
  };

  setStateInfo = (info) => {
    this.setState({
      stateInfo: info,
    });
  };

  setLegend = (src) => {
    this.setState({
      legend: src,
    });
  };

  setLatLng = (latlng) => {
    this.setState({
      latlng: latlng,
    });
  };

  setOnClickDetails = (data) => {
    this.setState({
      onClickDetails: data,
    });
  };

  setViewport = (viewport) => {
    this.setState({
      viewport: viewport,
    });
  };

  async makeChartDataAvailableDays() {
    this.setState({ chartloading: true });
    let availableDatesStr = [],
      chartData = [];
    let chartDates = [];
    console.log(this.state.selectedMenu);
    // let chartData
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-pixel-value-${this.state.selectedMenu
        .split(" ")
        .join("-")
        .toLowerCase()}`,
      data: {
        lat: this.state.latlng.lat,
        lon: this.state.latlng.lng,
      },
    });
    let activeDate = moment.isMoment(this.state.date)
      ? this.state.date.format("YYYYMMDD")
      : moment(this.state.date, "DD-MM-YYYY").format("YYYYMMDD");
    if (result) {
      if (result.data) {
        result.data.map((item) => {
          var date = item.filename.match(/\d{4}\d{2}\d{2}/g)[0];
          availableDatesStr.push(moment(date).format("YYYYMMDD"));
          console.log(activeDate);
          console.log(date);
          if (activeDate === date) {
            console.log("true");
            this.setState({
              pointInfo:
                item.pixel_val !== null ? item.pixel_val.toFixed() : null,
            });
          }
          return true;
        });

        result.data.map((r) => {
          chartData.push(Number(r.pixel_val).toFixed(3));
          return true;
        });
        console.log(chartData);
        // availableDatesStr.reverse()
        // console.log(availableDatesStr)

        // console.log(availableDatesStr.length)
        availableDatesStr.forEach((date_i) => {
          chartDates.push(moment(date_i, "YYYYMMDD").format("D MMM YYYY"));
          return true;
        });
        console.log(chartDates);

        let data2 = [];
        for (let i = 0; i < chartDates.length; i++) {
          let dd = new Date(chartDates[i]);
          console.log(dd);
          let y = dd.getFullYear();
          let m = dd.getMonth();
          let d = dd.getDate();
          data2.push([Date.UTC(y, m, d), chartData[i]]);
        }
        data2.sort();

        var dates = data2.map(function (x) {
          return new Date(x[0]);
        });
        console.log(new Date(Math.max.apply(null, dates)));
        this.setState({
          pointInfo: chartData[0],

          chartData: {
            seriesData: data2,
            categories: chartDates,
            title: `${this.state.selectedMenu}`,
            yAxisTitle: `value (mm)`,
            xAxisTitle: "Days",
            name: this.state.selectedMenu,
            type: "area",
            maximumDate: new Date(Math.max.apply(null, dates)),
            minimumDate: new Date(Math.min.apply(null, dates)),
          },
          chartloading: false,
        });
      }
    }
  }

  handleDateChange = (event, { name, value }) => {
    let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let availableDates = [...this.state.availableDates];
    let availableDatesStr = availableDates.map((date) => {
      return moment(date, "DD-MM-YYYY").format("YYYYMMDD");
    });

    // selectedLayer["Evapotranspiration"]=et_file_head+selected_date
    // selectedLayer["Soil Heat Flux"]=dshf_file_head+selected_date
    // selectedLayer["Net Radiation"]=dnr_file_head+selected_date

    selectedLayer[this.state.selectedMenu] =
      file_ext[this.state.selectedMenu] + selected_date;

    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,
        selectedLayer: selectedLayer,
        slideTracker: availableDatesStr.indexOf(selected_date),
        layerExist: true,
      });
    }
  };

  onSlide = (event) => {
    event.preventDefault();
    let value = parseInt(event.target.value, 10);

    let selected_date = moment(
      this.state.availableDates[value],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };

    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = file_ext[menu] + selected_date;
    // })

    this.setState({
      slideTracker: value,
      date: this.state.availableDates[value],
      selectedLayer: selectedLayer,
    });
  };

  onClickSlideLeft = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker > 0) {
      slideTracker = slideTracker - 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };

    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = file_ext[menu] + selected_date;
    // })

    this.setState({
      slideTracker: slideTracker,
      date: this.state.availableDates[slideTracker],
      selectedLayer: selectedLayer,
    });
  };

  onClickSlideRight = () => {
    let slideTracker = this.state.slideTracker;
    if (slideTracker < this.state.availableDates.length - 1) {
      slideTracker = slideTracker + 1;
    }

    let selected_date = moment(
      this.state.availableDates[slideTracker],
      "DD-MM-YYYY"
    ).format("YYYYMMDD");
    let selectedLayer = { ...this.state.selectedLayer };
    let menu = this.state.selectedMenu;
    // Object.keys(file_ext).forEach((menu)=>{
    selectedLayer[menu] = file_ext[menu] + selected_date;
    // })

    this.setState({
      slideTracker: slideTracker,
      date: this.state.availableDates[slideTracker],
      selectedLayer: selectedLayer,
    });
  };

  getBaseLayer = (value) => {
    // axios.get(`${domain.Geoserver}geoserver/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=nhp_irrigation:narayanpur&outputFormat=json&dataType=jsonp`).then((result)=>
    // {
    //    this.setState({
    //        studyarea:result.data,
    //        loading:true
    //    })
    // })
    // axios.get(`${domain.DBServer}/get-narayanpur-boundary`).then((result) => {
    //   if (result) {
    //     this.setState({
    //       studyarea: result.data[0].studyarea,
    //       loading: true,
    //     });
    //   }
    // });

    axios.get(`${domain.DBServer}/fetch-irrigation-command-geom/${value}`).then((result) => {
      // axios.get(`${domain.DBServer}/fetch-nhp-nar-dist-geom`).then((result) => {
      if (result) {
        this.setState({
          studyarea: result.data[0].basin_boundary,
          loading: true,
          commandAreaName:result.data[0].basin_boundary['features'][0]['properties']['full_name']
        });
      }
      //console.log("dasdsadas" + result.data[0].basin_boundary['features'][0]['properties']['full_name'])
    });


  };

  getCropYears = async () => {
    let result = await axios.get(`${domain.DBServer}/fetch-crop-years`)
    if (result) {
      let year
      if (result.data) {
        year = Math.max.apply(Math, result.data.map(function (o) { return o.year; }))
        
      }
      let result1=await axios.get(`${domain.DBServer}/fetch-crop-year-season/${year}`)
      if(result1)
      {
       // console.log(year)
        this.setState({
          cropmapyears: result.data,
           cropyear: year,
           cropseason:'kharif',
           cropmapseasons:result1.data
        })
      }
     
    }
  }

  getHistoricSeasonDetails = (year, cat) => {

    let url;

    let menu = (cat === "Crop Map Historic") ? 'ca' : (cat === "Irrigation Requirement") ? 'gir' : (cat === "Irrigation System Performance") ? 'cwsim' : null; 

    if(!menu) return;
    
    url = `${domain.DBServer}/fetch-nhp-nar-curr-layer/${menu}/${year}`;

    console.log('Test 123 url', url);

    axios.get(url).then((result) => {
      if (result) {
        console.log('Test 123 yr se', result.data);

        this.setState({
          hist_cropmapseasons: result.data,
          hist_cropseason: null,
        });

      }
    });

  }

  getHistoricYearDetails = () => {

    axios.get(`${domain.DBServer}/fetch-nhp-nar-curr-year/gir`).then((result) => {
      if (result) {
        console.log('Test 123 hist', result.data);

        let gir_years = result.data.map((x) => {
          return x.year
        });

        this.setState({
          girHistYears : gir_years.sort(),
        });
      }
    });

    axios.get(`${domain.DBServer}/fetch-nhp-nar-curr-year/ca`).then((result) => {
      if (result) {
        console.log('Test 123 hist', result.data);

        let ca_years = result.data.map((x) => {
          return x.year
        });

        this.setState({
          caHistYears : ca_years.sort(),
          hist_years : ca_years.sort(),
        });
      }
    });

    axios.get(`${domain.DBServer}/fetch-nhp-nar-curr-year/cwsim`).then((result) => {
      if (result) {
        console.log('Test 123 hist', result.data);

        let cwsim_years = result.data.map((x) => {
          return x.year
        });

        this.setState({
          cwsimHistYears : cwsim_years.sort(),
        });
      }
    });


  }

  getCurrentSeasonLayers = () => {

    axios.get(`${domain.DBServer}/fetch-nhp-nar-curr-latest`).then((result) => {
      if (result) {

        console.log('Test 123', result.data);

        let ca_layer, cwsim_layer, ca_date, cwsim_date;

        if (result.data[0].category === 'ca') {
          ca_layer = result.data[0].layername;
          ca_date = result.data[0].date.substring(6, 8) + '.' + result.data[0].date.substring(4, 6) + '.' + result.data[0].date.substring(0, 4);

          cwsim_layer = result.data[1].layername;
          cwsim_date = result.data[1].date.substring(6, 8) + '.' + result.data[1].date.substring(4, 6) + '.' + result.data[1].date.substring(0, 4);
        } else {
          ca_layer = result.data[1].layername;
          ca_date = result.data[1].date.substring(6, 8) + '.' + result.data[1].date.substring(4, 6) + '.' + result.data[1].date.substring(0, 4);

          cwsim_layer = result.data[0].layername;
          cwsim_date = result.data[0].date.substring(6, 8) + '.' + result.data[0].date.substring(4, 6) + '.' + result.data[0].date.substring(0, 4);
        }

        console.log('Test 123 ca', ca_layer);
        // console.log('Test 123 ca', ca_date);

        console.log('Test 123 cw', cwsim_layer);
        // console.log('Test 123 cw', cwsim_date);

        this.setState({
          cropAreaLayer: ca_layer,
          cropAreaDate: ca_date,
          cwismLayer: cwsim_layer,
          cwismDate: cwsim_date,
          // cropAreaName:this.state.commandAreaName,
        });
        //console.log('dadasdasdad'+this.state.commandAreaName)
      }
    });


  }

  componentDidMount() {
    this.getCurrentSeasonLayers();
    this.getIrrigationCommand();
    this.getCommandAreaDetails('NIS');
    this.getBaseLayer('NIS');
    this.getCropYears();
    this.getHistoricYearDetails();
    this.getIrrigationRequirements();
    



    if (window.innerWidth < 1025) {
      this.setState({
        visible: false,
        legendVisible: false,
        x: 0,
        y: 0,
        width: 300,
        height: 300
      })
    }
    // console.log(this.props.selected)
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.satellite !== prevState.satellite ||
      this.state.year !== prevState.year ||
      this.state.season !== prevState.season ||
      this.state.date !== prevState.date ||
      this.state.cropyear!==prevState.cropyear ||
      this.state.cropseason!==prevState.cropseason

    ) {
      // let selectedLayer={...this.state.selectedLayer}

      this.setSelectedLayer(this.state.selectedMenu);

      // selectedLayer[this.state.selectedMenu] = file_ext[this.state.selectedMenu]+"_"+this.state.satellite+"_"+this.state.year+"_"+this.state.season

      //     this.setState({

      //         selectedLayer:selectedLayer,
      //        // slideTracker:availableDatesStr.indexOf(selected_date),

      //     });
      // if(this.state.selectedMenu==='Crop Water Demand-Crop Water Requirement' ||  this.state.selectedMenu==='Crop Water Demand-Irrigation Water Requirement')
      //  this.makeChartDataAvailableDays()
    }
    if (this.state.selectedMenu !== prevState.selectedMenu) {
      // console.log(this.state.selectedMenu)
      //  this.makeChartDataAvailableDays()
    }
  }
  doSateliteChange = (newValue, selectedMenu) => {

    if(selectedMenu === 'Satellite Imagery-Optical') {
      this.setState({
        selectedOpticalSensor: newValue,
        selectedSatelliteLayer: null,
        selectedOpticalYear: '#',
        selectedOpticalSeason: '#',
        selectedOpticalDate: '#'
      })
    }
    if(selectedMenu === 'Satellite Imagery-Microwave') {
      this.setState({
        selectedMWSensor: newValue,
        selectedSatelliteLayer: null,
        selectedMWYear: '#',
        selectedMWSeason: '#',
        selectedMWDate: '#'
      })
    }

    this.getSensorYears(newValue, selectedMenu);
  };


  cropyearChange = async (value) => {
    if (value !== '#') {

      // this.setState({

      // });
      console.log(value)
      let result = await axios.get(`${domain.DBServer}/fetch-crop-year-season/${value}`)
      console.log(result)
      if (result) {
        this.setState({
          cropmapseasons: result.data,
          cropyear: value,
          cropseason: "kharif",
        })
      }
    }
    // this.seasonChange('Kharif')
  };

  cropseasonChange = (newValue) => {
    this.setState({
      cropseason: newValue,
    });
  };

  histcropseasonChange = (newValue) => {
    this.setState({
      hist_cropseason: newValue,
    });

    // console.log('Test 123 sm', this.state.selectedMenu);

    let test = (this.state.selectedMenu === 'Historical Season-Crop Map Historic') ? 'ca': (this.state.selectedMenu === 'Historical Season-Irrigation Requirement') ? 'gir' : (this.state.selectedMenu === 'Historical Season-Irrigation System Performance') ? 'cwsi' : null;

    if (test) this.getHistoricStats(this.state.selectedCommandArea, this.state.hist_selectedyear, newValue, test);
  };

  getHistoricStats = (commandArea, year, season, menu) => {
    axios.get(`${domain.DBServer}/fetch-nhp-nar-${menu}-hist/${commandArea}/${year}/${season.split('###')[1]}`).then((result) => {
      if (result) {
        console.log('Test 123 stat', result.data);

        if(result.data.length === 0) return;

        if(menu === 'ca') {
          this.setState({
            caHistStats : result.data,
            visibleGraphPanel : true
          });
        }

        if(menu === 'gir') {
          this.setState({
            girHistStats : result.data,
            visibleGraphPanel : true
          });
        }

        if(menu === 'cwsi') {

          let stats=[], cwsiData = result.data[0];

          console.log('Test 123 cwsi', cwsiData);

          stats.push(parseFloat(cwsiData.good));
          stats.push(parseFloat(cwsiData.average));
          stats.push(parseFloat(cwsiData.poor));

          this.setState({
            cwsiHistStats : stats,
            cwsiHistStats1 : cwsiData,
            visibleGraphPanel : true
          });          
        }

        
      }
    });

    

  };


  histyearChange = (newValue, menu) => {
    this.setState({
      hist_cropmapseasons: [],
      hist_selectedyear: newValue,
    });

    this.getHistoricSeasonDetails(newValue, menu);
  };


  yearChange = (newValue, selectedMenu) => {

    if(selectedMenu === 'Satellite Imagery-Optical') {
      this.setState({
        selectedOpticalYear: newValue,
        selectedSatelliteLayer: null,
        selectedOpticalSeason: '#',
        selectedOpticalDate: '#'
      })
    }
    if(selectedMenu === 'Satellite Imagery-Microwave') {
      this.setState({
        selectedMWYear: newValue,
        selectedSatelliteLayer: null,
        selectedMWSeason: '#',
        selectedMWDate: '#'
      })
    }

    this.getSensorYearSeasons(newValue, selectedMenu);

    // if (value !== '#') {
    //   this.setState({
    //     year: value,
    //     season: "kharif",
    //   });
    // }
  };


  seasonChange = (newValue, selectedMenu) => {
    if(selectedMenu === 'Satellite Imagery-Optical') {

      // let selectedSeason = this.state.opticalSeasons.filter((item) => item.season === newValue);

      this.setState({
        selectedOpticalSeason: newValue,
        selectedSatelliteLayer: null,
        selectedOpticalDate: '#'
        // selectedSatelliteLayer: selectedSeason[0].layername
      })
    }
    if(selectedMenu === 'Satellite Imagery-Microwave') {

      // let selectedSeason = this.state.mwSeasons.filter((item) => item.season === newValue);

      this.setState({
        selectedMWSeason: newValue,
        selectedSatelliteLayer: null,
        selectedMWDate: '#'
        // selectedSatelliteLayer: selectedSeason[0].layername
      })
    }

    this.getSensorYearSeasonDates(newValue, selectedMenu);

  };

  dateChange = (newValue, selectedMenu) => {
    if(selectedMenu === 'Satellite Imagery-Optical') {

      let selectedSeason = this.state.opticalDates.filter((item) => item.date === newValue);

      this.setState({
        selectedOpticalDate: newValue,
        selectedSatelliteLayer: selectedSeason[0].layername
      })
    }
    if(selectedMenu === 'Satellite Imagery-Microwave') {

      let selectedSeason = this.state.mwDates.filter((item) => item.date === newValue);

      this.setState({
        selectedMWDate: newValue,
        selectedSatelliteLayer: selectedSeason[0].layername
      })
    }
  };


  increment = () => {
    let year_m = this.state.year;
    if (year_m >= 2019) return;
    else {
      year_m = Number(this.state.year) + 1;
      this.setState({ year: year_m });
    }
  };

  decrement = () => {
    if (this.state.satellite === "landsat8") {
      let year_m = this.state.year;
      if (year_m <= 2013) return;
      else {
        year_m = Number(this.state.year) - 1;
        this.setState({ year: year_m });
      }
    } else if (this.state.satellite === "sentinel2") {
      let year_m = this.state.year;
      if (this.state.selectedMenu === "Satellite Imagery-Optical") {
        if (year_m <= 2018) return;
        else {
          year_m = Number(this.state.year) - 1;
          this.setState({ year: year_m });
        }
      } else {
        if (year_m <= 2013) return;
        else {
          year_m = Number(this.state.year) - 1;
          this.setState({ year: year_m });
        }
      }
    } else if (this.state.satellite === "sentinel1") {
      let year_m = this.state.year;
      if (year_m <= 2018) return;
      else {
        year_m = Number(this.state.year) - 1;
        this.setState({ year: year_m });
      }
    }
  };

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 40;
    let height = 20;

    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&dx:0.2;dy:0.2;mx:0.2;my:0.2;borderColor:FF00ff;border:true;fontColor:#0000ff;fontSize:14`;

    return img_src;
  }

  getLegend = (overlay) => {
    let wms_url = this.state.wms_url;

    let legend_array_overlay = {};

    overlay.map((layer) => {
      if (layer.isChecked) {
        this.getLegendGraphic(wms_url, "nhp_irrigation:" + layer.value).then(
          (legend) => {
            console.log(legend);
            legend_array_overlay[layer.value] = legend;
            this.setState({
              legend_array_overlay: legend_array_overlay,
              legendVisible: true,
            });
          }
        );
      } else {
        this.setState({
          legend_array_overlay: null,
          legendVisible: true,
        });
      }
      return true;
    });
  };

  handleCheckChieldElement = (event) => {
    let overlay = this.state.basinoverlays;
    let array = [];
    overlay.forEach((overlay) => {
      if (overlay.value === event.target.value) {
        overlay.isChecked = event.target.checked;

        array.push(overlay.value);
      }
      //    else
      // //    {
      // //        array.pop()
      // //    }
    });
    let result = overlay.every((item) => item.isChecked === false);
    console.log(result);

    this.getLegend(overlay);
    this.setState({ basinoverlays: overlay, arraycheck: array });
  };
  handleSwipeChange = (event) => {
    this.setState({
      swipevalue: event.target.value,
    });
  };

  handleDialogClose = () => {
    this.setState({
      technicalnoteenable: false,
    });
  };

  handleDialogCloseD = () => {
    this.setState({
      distributary_details_visibility: false,
      
    });
  };

  handleDialogDClose = () => {
    this.setState({
      disclaimerenable: false,
    });
  };
  handleDialogIClose = () => {
    this.setState({
      IndexDiagramEnable: false,
    });
  };
  handleTechnicalNote = () => {
    this.setState({
      technicalnoteenable: true,
      disclaimerenable: false,
      IndexDiagramEnable: false,
      visibleGraphPanel: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };
  handleDisclaimer = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: true,
      IndexDiagramEnable: false,
      visibleGraphPanel: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };

  handleIndexDiagram = () => {
    this.setState({
      technicalnoteenable: false,
      disclaimerenable: false,
      IndexDiagramEnable: true,
      visibleGraphPanel: false,
      visible: window.innerWidth > 1000 ? true : false,
    });
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    console.log(this.state);
    let params = new URLSearchParams(this.props.location.search);
    console.log(params.get("selected"));
    console.log("irrii",params)


    this.getSensors(this.state.selectedMenu);

    console.log('Sat 123', '123');

    let menuList = menus.mapSideBar.map((child) => {
      return (
        <div
          style={{
            padding: "1px",
            borderRadius: "4px",
            margin: "4px",
            backgroundColor: colors.final_side_sub,
          }}
          key={child.id}
        >
          <TreeNode
            data={child}
            cropmapseasons={this.state.cropmapseasons}
            cropmapyears={this.state.cropmapyears}
            cropyear={this.state.cropyear}
            cropseason={this.state.cropseason}
            doSateliteChange={this.doSateliteChange}
            seasonChange={this.seasonChange}
            dateChange={this.dateChange}
            yearChange={this.yearChange}
            cropseasonChange={this.cropseasonChange}
            cropyearChange={this.cropyearChange}
            increment={this.increment}
            decrement={this.decrement}
            season={this.state.season}
            year={this.state.year}
            setSelectedMenu={this.setSelectedMenu}
            margin={0}
            color={colors["sidebar-main-menu"]}
            selectedLayerLink={params.get("selected")}
            toggleSelectedNodeStatus={this.toggleSelectedNodeStatus}
            selectedNodeStaus={this.state.selectedNodeStaus}
            selectedMenu={this.state.selectedMenu}
            setSelectedLayer={this.setSelectedLayer}
            // activeDate = {moment.isMoment(this.state.date)?this.state.date.format(this.state.dateDisplayFormat):moment(this.state.date,this.state.dateDisplayFormat).format(this.state.dateDisplayFormat)}
            slideTracker={this.state.slideTracker}
            handleDateChange={this.handleDateChange}
            // availableDates= {this.state.availableDates}
            // date={this.state.date}
            // getAvailableDates={this.getAvailableDates.bind(this)}
            enableDatePicker={this.enableDatePicker}
            enableYearSeason={this.enableYearSeason}

            ca_areas = {this.state.ca_areas}
            doCommandAreaChange = {this.doCommandAreaChange}
            selectedCommandArea = {this.state.selectedCommandArea}

            histcropseasonChange={this.histcropseasonChange}
            histyearChange={this.histyearChange}
            hist_cropmapseasons={this.state.hist_cropmapseasons}
            hist_cropseason={this.state.hist_cropseason}

            caHistYears = {this.state.caHistYears}
            girHistYears = {this.state.girHistYears}
            cwsimHistYears = {this.state.cwsimHistYears}

            caHistSeasons = {this.state.caHistSeasons}
            girHistSeasons = {this.state.girHistSeasons}
            cwsimHistSeasons = {this.state.cwsimHistSeasons}

            opticalSensors ={this.state.opticalSensors}
            opticalYears ={this.state.opticalYears}
            opticalSeasons ={this.state.opticalSeasons}
            opticalDates ={this.state.opticalDates}
            selectedOpticalSensor ={this.state.selectedOpticalSensor}
            selectedOpticalYear ={this.state.selectedOpticalYear}
            selectedOpticalSeason ={this.state.selectedOpticalSeason}
            selectedOpticalDate ={this.state.selectedOpticalDate}

            mwSensors ={this.state.mwSensors}
            mwYears ={this.state.mwYears}
            mwSeasons ={this.state.mwSeasons}
            mwDates ={this.state.mwDates}
            selectedMWSensor ={this.state.selectedMWSensor}
            selectedMWYear ={this.state.selectedMWYear}
            selectedMWSeason ={this.state.selectedMWSeason}
            selectedMWDate ={this.state.selectedMWDate}
            
          />
        </div>
      );
    });

    //   console.log(this.props.history)

    return (
      <div style={{ backgroundColor:colors.textcolor, height: "100%" }}>
        <AboutModal
          modal={this.props.irrmodal}
          toggle={this.props.toggle}
          title={pagecontent.title}
          bodycontent={pagecontent.bodycontent}
          link={pagecontent.link}
        />      

        <Sidebar.Pushable
          as={Segment}
          style={{
            marginTop: "0px",
            backgroundColor: colors.background,
            border: "0px",
          }}
        >
          <Sidebar
            as={Menu}
            animation="slide out"
            direction="left"
            icon="labeled"
            inverted
            vertical
            visible={this.state.visible}
            // width='wide'
            style={{
              backgroundColor: colors.sidebarBackground,
              textAlign: "right",
              width: "260px",
              padding: "0px",
              border: "0px",
            }}
          >
            {/* {  this.state.dateEnabled || this.state.yearseasonEnabled  ? <div style={{textAlign:"center",margin:"5px"}}>
                         
                        <div>
                         {this.state.dateEnabled ? this.state.selectedMenu!=="Satellite Imagery-Microwave"?   <div> 
                             
                        <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Satellite</legend>
                        <SegmentedControl
                        name="Satellite"
                        options={[
                            { label: "Landsat 8", value: "landsat8" },
                            { label: "Sentinel 2", value: "sentinel2",default:true },
                            
                            
                        ]}
                         setValue={newValue => this.doSateliteChange(newValue)}
                        style={{ width: 200, color: 'rgb(47,84,235)' }} 
                        /></fieldset></div> : <div> 
                             
                        <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Satellite</legend>
                        <SegmentedControl
                        name="Satellite"
                        options={[
                         
                            { label: "Sentinel 1", value: "sentinel1",default:true },
                          
                            
                        ]}
                         setValue={newValue => this.doSateliteChange(newValue)}
                        style={{ width: 200, color: 'rgb(47,84,235)' }} 
                        /></fieldset></div>:null
                    }
                                                        
                        <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Year</legend>
                            <div className="quantity-input">
                            <button className="quantity-input__modifier quantity-input__modifier--left" onClick={this.decrement}>
                           &lt;
                            </button>
                            <input className="quantity-input__screen" type="text" value={this.state.year} readOnly />
                            <button className="quantity-input__modifier quantity-input__modifier--right" onClick={this.increment}>
                          &gt;
                            </button>  
                        </div>  
 


                        </fieldset>
                        <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Season</legend>
                            <SegmentedControl 
                            name="Season"
                            options={[
                            { label: "Kharif", value: "kharif",default:true  },
                            { label: "Rabi", value: "rabi"},
                            
                            
                        ]}
                         setValue={newValue => this.seasonChange(newValue)}
                        style={{ width: 200, color: 'rgb(47,84,235)' }} 
                        />
                        </fieldset>
                            </div>
                       
                      


                         
                 
                     
                 </div>:null} */}

            {this.state.layerExist === true ? (
              <div></div>
            ) : (
                <div style={{ padding: "10px", textAlign: "left" }}>
                  <Message warning>
                    <Message.Header>Data does not exist </Message.Header>
                    <p>
                      Data does not exist for the selected date. The data being
                      displayed is for the last date selected.
                  </p>
                  </Message>
                </div>
              )}

            {menuList}

            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
              >
                Report
              </div>

              <div className="modalbox">
                <ul>
                  {/* <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleIndexDiagram}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Index Map{" "}
                    </a>
                  </li> */}
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    // onClick={this.handleIndexDiagram}
                  >
                    <a style={{ textDecoration: "underline" }} href={pdf} target="blank">Weekly Bulletin</a>
                  </li>

                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    // onClick={this.handleIndexDiagram}
                  >
                    <a style={{ textDecoration: "underline" }} href={pdfSeasonal} target="blank">Seasonal Bulletin</a>
                  </li>

                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleIndexDiagram}
                  >
                    <a style={{ textDecoration: "underline" }}> Index Diagram</a>
                  </li>


                </ul>
              </div>
            </div>


            <div className="modalwindow">
              <div className="modalheader" style={{ textAlign: "left" }}>
                Overlay
              </div>
              <div
                className="modalbox"
                style={{ textAlign: "left", margin: "0px", padding: "0px" }}
              >
                <ul style={{ padding: "0px", margin: "0px" }}>
                  {this.state.basinoverlays.map((overlays) => {
                    console.log('Over', overlays);

                    return (
                      <>
                        <CheckBox
                          handleCheckChieldElement={this.handleCheckChieldElement}
                          {...overlays}
                        />
                        {(overlays.info && overlays.isChecked && this.state.selectedMenu === 'Current Season-Command Area' ) ? (<>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*click on map for info
                        </>) : null}
                      </>
                    );
                  })}
                </ul>
                {this.state.arraycheck.length > 0 &&
                  !this.state.basinoverlays.every(
                    (item) => item.isChecked === false
                  ) ? (
                    // <div className="modalbox" style={{ textAlign: "center" }}>
                    //   Swipe Overlay{" "}
                    //   <input
                    //     id="range"
                    //     class="range"
                    //     type="range"
                    //     min="0"
                    //     max="1.0"
                    //     step="any"
                    //     value={this.state.swipevalue}
                    //     onChange={this.handleSwipeChange}
                    //   />
                    // </div>
                    null
                  ) : null}
                {/* <Button  onClick={this.handleChange} ref={this.RangeRef}/> */}
                {/* <input id='range' class='range' type='range' min='0' max='1.0' step='any' value={this.state.value} onChange={this.handleChange} /> */}
              </div>
            </div>
            <div className="modalwindow">
              <div
                className="modalheader"
                style={{ color: colors.textcolor, textAlign: "left" }}
              >
                Information
              </div>

              <div className="modalbox">
                <ul>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleTechnicalNote}
                  >
                    <a style={{ textDecoration: "underline" }}>
                      Technical Note{" "}
                    </a>
                  </li>
                  <li
                    style={{ textAlign: "left", margin: "2px" }}
                    onClick={this.handleDisclaimer}
                  >
                    <a style={{ textDecoration: "underline" }}> Disclaimer</a>
                  </li>
                </ul>
              </div>
            </div>

          </Sidebar>

          <Sidebar.Pusher
            dimmed={false}
            style={{ height: "100%", border: "0px" }}
          >
            {/* <Grid  columns='equal' divided inverted style={{marginLeft:"0rem", marginRight:"-2rem"}}>
                        <Grid.Row columns={1} style={{paddingTop:"1em", paddingBottom:"0em"}}>
                            <Grid.Column > */}

            {
              console.log('selectedL', this.state.selectedLayer)}{
              console.log('selectedM', this.state.selectedMenu)
            }

            




            {/* <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "0px",
                border: "0px",
              }}
            >
              <MapView
                handleSwipeChange={this.handleSwipeChange}
                swipevalue={this.state.swipevalue}
                arraycheck={this.state.arraycheck}
                legend_array_overlay={this.state.legend_array_overlay}
                basinoverlays={this.state.basinoverlays}
                legend={this.state.legend}
                setLatLng={this.setLatLng}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                pointInfo={this.state.pointInfo}
                setLegend={this.setLegend}
                selectedLayer={this.state.selectedLayer}
                visibleLeft={this.state.visible}
                visibleGraphPanel={this.state.visibleGraphPanel}
                handleAnimationChange={this.handleAnimationChange}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                getFeatureInfo={this.getFeatureInfo}
                setStateInfo={this.setStateInfo}
                // activeDate ={this.state.date}
                activeDate={
                  moment.isMoment(this.state.date)
                    ? this.state.date.format("DD MMMM YYYY")
                    : moment(this.state.date, "DD-MM-YYYY").format(
                      "DD MMMM YYYY"
                    )
                }
                // setChartData={this.setChartData}
                // availableDates = {this.state.availableDates}
                // makeChartDataNDays={this.makeChartDataNDays}
                makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                onClickDetails={{ ...this.state.onClickDetails }}
                setOnClickDetails={this.setOnClickDetails}
                stateInfo={
                  this.state.stateInfo
                    ? {
                      key: this.state.stateInfo.id,
                      geojson: { ...this.state.stateInfo },
                    }
                    : null
                }
                sliderOptions={{
                  onClickSlideLeft: this.onClickSlideLeft,
                  onClickSlideRight: this.onClickSlideRight,
                  onSlide: this.onSlide,
                  slideTracker: this.state.slideTracker,
                  max: this.state.availableDates.length - 1,
                  date: moment(
                    this.state.availableDates[this.state.slideTracker],
                    "YYYYMMDD"
                  ).format("D MMM YYYY"),
                }}
                wms_url_base_layers={this.state.wms_url_base_layers}
                studyarea={this.state.studyarea}
                satellite={this.state.satellite}
                year={this.state.year}

                season={this.state.season}
                cropyear={this.state.cropyear}
                cropseason={this.state.cropseason}
              // setSelectedMainMenu={this.setSelectedMainMenu}
              // selectedMainMenu={this.state.selectedMainMenu}
              />


            </Segment> */}

            <Segment
              basic
              style={{
                width: "100%",
                height: "100%",
                padding: "0px",
                border: "0px",
              }}
            >
              {/* <MapView
                handleSwipeChange={this.handleSwipeChange}
                swipevalue={this.state.swipevalue}
                arraycheck={this.state.arraycheck}
                legend_array_overlay={this.state.legend_array_overlay}
                basinoverlays={this.state.basinoverlays}
                legend={this.state.legend}
                setLatLng={this.setLatLng}
                markerPosition={[28.613, 77.209]}
                selected={this.state.selectedMenu}
                pointInfo={this.state.pointInfo}
                setLegend={this.setLegend}
                selectedLayer={this.state.selectedLayer}
                visibleLeft={this.state.visible}
                visibleGraphPanel={this.state.visibleGraphPanel}
                handleAnimationChange={this.handleAnimationChange}
                handleVisibleGraphPanelOnMapClick={
                  this.handleVisibleGraphPanelOnMapClick
                }
                toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                getFeatureInfo={this.getFeatureInfo}
                setStateInfo={this.setStateInfo}
                // activeDate ={this.state.date}
                activeDate={
                  moment.isMoment(this.state.date)
                    ? this.state.date.format("DD MMMM YYYY")
                    : moment(this.state.date, "DD-MM-YYYY").format(
                      "DD MMMM YYYY"
                    )
                }
                // setChartData={this.setChartData}
                // availableDates = {this.state.availableDates}
                // makeChartDataNDays={this.makeChartDataNDays}
                makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                onClickDetails={{ ...this.state.onClickDetails }}
                setOnClickDetails={this.setOnClickDetails}
                stateInfo={
                  this.state.stateInfo
                    ? {
                      key: this.state.stateInfo.id,
                      geojson: { ...this.state.stateInfo },
                    }
                    : null
                }
                sliderOptions={{
                  onClickSlideLeft: this.onClickSlideLeft,
                  onClickSlideRight: this.onClickSlideRight,
                  onSlide: this.onSlide,
                  slideTracker: this.state.slideTracker,
                  max: this.state.availableDates.length - 1,
                  date: moment(
                    this.state.availableDates[this.state.slideTracker],
                    "YYYYMMDD"
                  ).format("D MMM YYYY"),
                }}
                wms_url_base_layers={this.state.wms_url_base_layers}
                studyarea={this.state.studyarea}
                satellite={this.state.satellite}
                year={this.state.year}

                season={this.state.season}
                cropyear={this.state.cropyear}
                cropseason={this.state.cropseason}
              // setSelectedMainMenu={this.setSelectedMainMenu}
              // selectedMainMenu={this.state.selectedMainMenu}
              /> */}

{
          (this.state.selectedMenu === "Current Season-Command Area") ? 
          (




          <Grid 
            columns={2} 
            stackable 
            textAlign='center'
            style={{
              width: "100%",
              height: "100%",
              //padding: "0px",
              //border: "0px",
            }}
            >
                <Grid.Row 
                  verticalAlign='middle'
                  style={{
                    width: "100%",
                    height: "60%",
                    padding: "0px",
                    border: "0px",
                  }}
                  >
                  <Grid.Column
                    style={{
                      width: "50%",
                      height: "99%",
                      //padding: "0px",
                      //border: "0px",
                    }}
                  >
                    <MapView
                      handleSwipeChange={this.handleSwipeChange}
                      swipevalue={this.state.swipevalue}
                      arraycheck={this.state.arraycheck}
                      legend_array_overlay={this.state.legend_array_overlay}
                      basinoverlays={this.state.basinoverlays}
                      legend={this.state.legend}
                      setLatLng={this.setLatLng}
                      markerPosition={[28.613, 77.209]}
                      selected={this.state.selectedMenu}
                      pointInfo={this.state.pointInfo}
                      setLegend={this.setLegend}
                      selectedLayer={this.state.selectedLayer}
                      visibleLeft={this.state.visible}
                      visibleGraphPanel={this.state.visibleGraphPanel}
                      handleAnimationChange={this.handleAnimationChange}
                      handleVisibleGraphPanelOnMapClick={
                        this.handleVisibleGraphPanelOnMapClick
                      }
                      toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                      getFeatureInfo={this.getFeatureInfo}
                      setStateInfo={this.setStateInfo}
                      // activeDate ={this.state.date}
                      activeDate={
                        moment.isMoment(this.state.date)
                          ? this.state.date.format("DD MMMM YYYY")
                          : moment(this.state.date, "DD-MM-YYYY").format(
                            "DD MMMM YYYY"
                          )
                      }
                      // setChartData={this.setChartData}
                      // availableDates = {this.state.availableDates}
                      // makeChartDataNDays={this.makeChartDataNDays}
                      makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                      onClickDetails={{ ...this.state.onClickDetails }}
                      setOnClickDetails={this.setOnClickDetails}
                      stateInfo={
                        this.state.stateInfo
                          ? {
                            key: this.state.stateInfo.id,
                            geojson: { ...this.state.stateInfo },
                          }
                          : null
                      }
                      sliderOptions={{
                        onClickSlideLeft: this.onClickSlideLeft,
                        onClickSlideRight: this.onClickSlideRight,
                        onSlide: this.onSlide,
                        slideTracker: this.state.slideTracker,
                        max: this.state.availableDates.length - 1,
                        date: moment(
                          this.state.availableDates[this.state.slideTracker],
                          "YYYYMMDD"
                        ).format("D MMM YYYY"),
                      }}
                      wms_url_base_layers={this.state.wms_url_base_layers}
                      studyarea={this.state.studyarea}
                      satellite={this.state.satellite}
                      year={this.state.year}

                      season={this.state.season}
                      cropyear={this.state.cropyear}
                      cropseason={this.state.cropseason}
                    // setSelectedMainMenu={this.setSelectedMainMenu}
                    // selectedMainMenu={this.state.selectedMainMenu}

                      viewport={this.state.viewport}
                      setViewport={this.setViewport}
                      cropmap = {'ca'}

                      distributary_details={this.state.distributary_details}
                      distributary_details_visibility = {this.state.distributary_details_visibility}
                      handleMapClick={this.handleMapClick}

                      hist_cropseason={this.state.hist_cropseason}
                      selectedCommandArea={this.state.selectedCommandArea}

                      layers={this.state.layers}
                      url={this.state.url}
                      baselayerselected={this.state.baselayerselected}

                      changeBaseLayer={this.changeBaseLayer}

                      cropAreaLayer={this.state.cropAreaLayer}
                      cropAreaDate={this.state.cropAreaDate}
                      cwismLayer={this.state.cwismLayer}
                      cwismDate={this.state.cwismDate}
                      cropAreaName={this.state.commandAreaName}

                      handleDialogCloseD = {this.handleDialogCloseD}

                      selectedOpticalSensor ={this.state.selectedOpticalSensor}
                      selectedOpticalYear ={this.state.selectedOpticalYear}
                      selectedOpticalSeason ={this.state.selectedOpticalSeason}

                      selectedMWSensor ={this.state.selectedMWSensor}
                      selectedMWYear ={this.state.selectedMWYear}
                      selectedMWSeason ={this.state.selectedMWSeason}

                      selectedSatelliteLayer = {this.state.selectedSatelliteLayer}

                      
                    />
                  </Grid.Column>

                  <Divider vertical inverted/>

                  <Grid.Column
                    style={{
                      width: "50%",
                      height: "99%",
                      //padding: "0px",
                      //border: "0px",
                    }}
                  >
                  <MapView
                      handleSwipeChange={this.handleSwipeChange}
                      swipevalue={this.state.swipevalue}
                      arraycheck={this.state.arraycheck}
                      legend_array_overlay={this.state.legend_array_overlay}
                      basinoverlays={this.state.basinoverlays}
                      legend={this.state.legend}
                      setLatLng={this.setLatLng}
                      markerPosition={[28.613, 77.209]}
                      selected={this.state.selectedMenu}
                      pointInfo={this.state.pointInfo}
                      setLegend={this.setLegend}
                      selectedLayer={this.state.selectedLayer}
                      visibleLeft={this.state.visible}
                      visibleGraphPanel={this.state.visibleGraphPanel}
                      handleAnimationChange={this.handleAnimationChange}
                      handleVisibleGraphPanelOnMapClick={
                        this.handleVisibleGraphPanelOnMapClick
                      }
                      toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                      getFeatureInfo={this.getFeatureInfo}
                      setStateInfo={this.setStateInfo}
                      // activeDate ={this.state.date}
                      activeDate={
                        moment.isMoment(this.state.date)
                          ? this.state.date.format("DD MMMM YYYY")
                          : moment(this.state.date, "DD-MM-YYYY").format(
                            "DD MMMM YYYY"
                          )
                      }
                      // setChartData={this.setChartData}
                      // availableDates = {this.state.availableDates}
                      // makeChartDataNDays={this.makeChartDataNDays}
                      makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                      onClickDetails={{ ...this.state.onClickDetails }}
                      setOnClickDetails={this.setOnClickDetails}
                      stateInfo={
                        this.state.stateInfo
                          ? {
                            key: this.state.stateInfo.id,
                            geojson: { ...this.state.stateInfo },
                          }
                          : null
                      }
                      sliderOptions={{ 
                        onClickSlideLeft: this.onClickSlideLeft,
                        onClickSlideRight: this.onClickSlideRight,
                        onSlide: this.onSlide,
                        slideTracker: this.state.slideTracker,
                        max: this.state.availableDates.length - 1,
                        date: moment(
                          this.state.availableDates[this.state.slideTracker],
                          "YYYYMMDD"
                        ).format("D MMM YYYY"),
                      }}
                      wms_url_base_layers={this.state.wms_url_base_layers}
                      studyarea={this.state.studyarea}
                      satellite={this.state.satellite}
                      year={this.state.year}

                      season={this.state.season}
                      cropyear={this.state.cropyear}
                      cropseason={this.state.cropseason}
                    // setSelectedMainMenu={this.setSelectedMainMenu}
                    // selectedMainMenu={this.state.selectedMainMenu}

                      viewport={this.state.viewport}
                      setViewport={this.setViewport}
                      cropmap = {'cwsi'}

                      distributary_details={this.state.distributary_details}
                      distributary_details_visibility = {this.state.distributary_details_visibility}
                      handleMapClick={this.handleMapClick}

                      hist_cropseason={this.state.hist_cropseason}
                      selectedCommandArea={this.state.selectedCommandArea}

                      layers={this.state.layers}
                      url={this.state.url}
                      baselayerselected={this.state.baselayerselected}

                      changeBaseLayer={this.changeBaseLayer}

                      cropAreaLayer={this.state.cropAreaLayer}
                      cropAreaDate={this.state.cropAreaDate}
                      cwismLayer={this.state.cwismLayer}
                      cwismDate={this.state.cwismDate}
                      cropAreaName={this.state.commandAreaName}

                      handleDialogCloseD = {this.handleDialogCloseD}

                      selectedOpticalSensor ={this.state.selectedOpticalSensor}
                      selectedOpticalYear ={this.state.selectedOpticalYear}
                      selectedOpticalSeason ={this.state.selectedOpticalSeason}
                      
                      selectedMWSensor ={this.state.selectedMWSensor}
                      selectedMWYear ={this.state.selectedMWYear}
                      selectedMWSeason ={this.state.selectedMWSeason}
                      
                      selectedSatelliteLayer = {this.state.selectedSatelliteLayer}

                    />

                  </Grid.Column>
                </Grid.Row>

                
                <Grid.Row 
                  verticalAlign='middle'
                  style={{
                    width: "100%",
                    height: "40%",
                    padding: '0px',
                    paddingLeft: "15px",
                    border: "1px",
                  }}
                  >

                    {/* <RFIRCharts
                      rf_data = {this.state.rf_data}
                      ir_data = {this.state.ir_data}
                      forecastdays = {this.state.forecastdays}
                      selection_min = {this.state.selection_min}
                      selection_max = {this.state.selection_max}
                      commandAreaName = {this.state.commandAreaName}
                      setSelectionMinMax = {this.setSelectionMinMax}
                    /> */}

{/* <Grid.Column
                    style={{
                      width: "25%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <Popup
                        on='click'
                        pinned
                        trigger={
                          <Button
                            size="tiny"
                            compact
                            style={{ 
                              padding: "8px",
                              right:'4px',
                              top:'4px',
                              position:'absolute',
                            }}
                          >
                                  <FontAwesomeIcon icon="info-circle" size="lg" />
                          </Button>
                        }
                        position="right center"
                      >
                    
                      <Popup.Content>
                        Data Source: <br /> Near Real Time Data –IMD,<br /> Forecast Data – GEFS

                      </Popup.Content>
                      
                     </Popup>

                    <b>Daily Rainfall for <br /> {this.state.commandAreaName} </b>
                    <RainfallChart 
                      rf_data = {this.state.rf_data}
                      ir_data = {this.state.ir_data}
                      forecastdays = {this.state.forecastdays}
                      selection_min = {this.state.selection_min}
                      selection_max = {this.state.selection_max}
                      setSelectionMinMax = {this.setSelectionMinMax}
                    />
                    </div>

                  </Grid.Column> */}

                  <Grid.Column
                    style={{
                      width: "40%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <Popup
                        on='click'
                        pinned
                        trigger={
                          <Button
                            size="tiny"
                            compact
                            style={{ 
                              padding: "8px",
                              right:'4px',
                              top:'4px',
                              position:'absolute',
                            }}
                          >
                                  <FontAwesomeIcon icon="info-circle" size="lg" />
                          </Button>
                        }
                        position="right center"
                      >
                    
                      <Popup.Content>
                        <div>
                        Data Source: <br /> Near Real Time Rainfall Data – <a  href="https://mausam.imd.gov.in/" target="_blank" rel="noopener noreferrer">IMD</a>
                        ,<br /> Forecast Rainfall Data – <a  href="https://www.ncei.noaa.gov/products/weather-climate-models/global-ensemble-forecast" target="_blank" rel="noopener noreferrer">GEFS</a>
                        </div>

                      </Popup.Content>
                      
                     </Popup>

                    <b>Daily Rainfall and Irrigation Requirement for <br /> {this.state.commandAreaName} </b>
                    <IrrigationChart 
                      rf_data = {this.state.rf_data}
                      ir_data = {this.state.ir_data}
                      forecastdays = {this.state.forecastdays}
                      selection_min = {this.state.selection_min}
                      selection_max = {this.state.selection_max}
                      setSelectionMinMax = {this.setSelectionMinMax}
                    />
                    </div>

                  </Grid.Column>
                  
                  {/* <Grid.Column
                    style={{
                      width: "25%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <b>Daily Irrigation Requirement for <br /> {this.state.commandAreaName} </b> 
                    <IrrigationChart 
                      ir_data = {this.state.ir_data}
                      rf_data = {this.state.rf_data}
                      forecastdays = {this.state.forecastdays}
                      selection_min = {this.state.selection_min}
                      selection_max = {this.state.selection_max}
                      setSelectionMinMax = {this.setSelectionMinMax}
                    />
                    </div>

                  </Grid.Column> */}



                  <Grid.Column
                    style={{
                      width: "30%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >
                    <div style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <Popup
                    on='click'
                    pinned
            trigger={
                         <Button
                            size="tiny"
                            compact
                            style={{ 
                              padding: "8px",
                              right:'4px',
                              top:'4px',
                              position:'absolute',
                            }}
                          >
                                  <FontAwesomeIcon icon="info-circle" size="lg" />
                          </Button>
            }
            position="right center"
          >
                    
                      <Popup.Content>
                        <div>
                        Data Source: <br /> MSI - <a  href="https://scihub.copernicus.eu/" target="_blank" rel="noopener noreferrer">Sentinel</a> 2A & 2B or <br /> OLI - <a  href="https://earthexplorer.usgs.gov/" target="_blank" rel="noopener noreferrer">Landsat</a> - 8/9
                        </div>
                      </Popup.Content>
                      

       </Popup>
                    <b style={{padding: '10px'}}>Crop Area Progress for  <br /> {this.state.commandAreaName} </b>
                    {/* <b style={{padding: '10px'}}>Crop Area Progress for {this.state.commandAreaName}  as on {this.state.cropAreaDate} </b> */}
                    <ColumnChart 
                      cap_stats_bi={this.state.cap_stats_bi}
                      cap_stats_date={this.state.cap_stats_date}
                      cap_stats_id={this.state.cap_stats_id}
                      cap_stats_paddy={this.state.cap_stats_paddy}
                      cap_stats_per={this.state.cap_stats_per}
                    /> 
                    </div>


                  </Grid.Column>
                  <Grid.Column
                    style={{
                      width: "30%",
                      height: "100%",
                      padding: "0px",
                      border: "1px",
                    }}
                  >

{/* <div style={{border: '1px black', borderStyle: 'solid', height: "100%", width: "100%"}}>
                    <Popup
            trigger={
              <Button
                            size="tiny"
                            // onClick={this.resetZoom}
                            compact
                            style={{
                              border:'1px solid black',
                              right:'4px',
                              position:'absolute',
                              width:'28px',
                              height:'28px',
                              WebkitBorderRadius:'30px',
                              MozBorderRadius:'30px',
                              textAlign:'center',
                              background:'white',
                            }}
                          >
                                  <b>i</b>
                          </Button>
            }
            position="right center"
          >
                    
                      <Popup.Content>Crop Water Stress Index (CWSI) is the ration actual evapotranspiration to potential evapotranspiration. (Data Source: MOD16A- MODIS Evapotranspiration Product)</Popup.Content>

       </Popup>
                    <b  style={{padding: '10px'}}>Water Requirement Satisfaction Index for <br/> {this.state.commandAreaName}</b>
                    
                    <b>( % of Command Area )</b> 
                    
      
                    <PieChart
                      series={this.state.cwsi_stats}
                      menu={this.state.selectedMenu}
                      pie_categories={this.state.cwsi_pie_categories}
                    />
                    </div> */}

                    <div style={{border: '1px black', overflow: 'auto', textAlign: '-webkit-center', borderStyle: 'solid', height: "100%", width: "100%"}}>
                     <br />
                    <b  style={{padding: '10px'}}> 
                    For the Time Period of {this.state.irr_req_startdate} to {this.state.irr_req_enddate}

                    </b>

                    <br />
                    <br />
                    <br />

                    <table style={{width:"98%"}}>
                      <tbody>
                      <tr>
                        <th rowspan="2"><b> Expected Rainfall (mm) </b></th>
                        <th colspan="6"><b> Estimated Irrigation Requirement (MCM) </b></th>
                      </tr>
                      <tr>
                        <th><b>NLBC Head</b></th>
                        <th><b>SBC Head</b></th>
                        <th><b>MBC Head</b></th>
                        <th><b>IBC Head</b></th>
                        <th><b>JBC Head</b></th>
                        <th><b>Total Command</b></th>
                        
                      </tr>
                      <tr>
                      <td>{this.state.irrigation_req_details["rainfall"]}</td>
                        <td>{this.state.irrigation_req_details["nlbc"]}</td>
                        <td>{this.state.irrigation_req_details["sbc"]}</td>
                        <td>{this.state.irrigation_req_details["mbc"]}</td>
                        <td>{this.state.irrigation_req_details["ibc"]}</td>
                        <td>{this.state.irrigation_req_details["jbc"]}</td>
                        <td>{this.state.irrigation_req_details["total_command"]}</td>
                      </tr>
                      </tbody>
                    </table>
                    
                    

                    </div>

                  </Grid.Column>

                </Grid.Row>

                </Grid>

                  )
                  : (
            // //         <Grid 
            // // columns={1} 
            // // // stackable 
            // // textAlign='center'
            // // style={{
            // //   width: "100%",
            // //   height: "100%",
            // //   //padding: "0px",
            // //   //border: "0px",
            // // }}
            // // >
            //     {/* <Grid.Row 
            //       verticalAlign='middle'
            //       style={{
            //         width: "100%",
            //         height: "100%",
            //         padding: "0px",
            //         border: "0px",
            //       }}
            //       >
            //       <Grid.Column
            //         style={{
            //           width: "100%",
            //           height: "100%",
            //           //padding: "0px",
            //           //border: "0px",
            //         }}
            //       > */}
                    <MapView
                      handleSwipeChange={this.handleSwipeChange}
                      swipevalue={this.state.swipevalue}
                      arraycheck={this.state.arraycheck}
                      legend_array_overlay={this.state.legend_array_overlay}
                      basinoverlays={this.state.basinoverlays}
                      legend={this.state.legend}
                      setLatLng={this.setLatLng}
                      markerPosition={[28.613, 77.209]}
                      selected={this.state.selectedMenu}
                      pointInfo={this.state.pointInfo}
                      setLegend={this.setLegend}
                      selectedLayer={this.state.selectedLayer}
                      visibleLeft={this.state.visible}
                      visibleGraphPanel={this.state.visibleGraphPanel}
                      handleAnimationChange={this.handleAnimationChange}
                      handleVisibleGraphPanelOnMapClick={
                        this.handleVisibleGraphPanelOnMapClick
                      }
                      toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                      getFeatureInfo={this.getFeatureInfo}
                      setStateInfo={this.setStateInfo}
                      // activeDate ={this.state.date}
                      activeDate={
                        moment.isMoment(this.state.date)
                          ? this.state.date.format("DD MMMM YYYY")
                          : moment(this.state.date, "DD-MM-YYYY").format(
                            "DD MMMM YYYY"
                          )
                      }
                      // setChartData={this.setChartData}
                      // availableDates = {this.state.availableDates}
                      // makeChartDataNDays={this.makeChartDataNDays}
                      makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                      onClickDetails={{ ...this.state.onClickDetails }}
                      setOnClickDetails={this.setOnClickDetails}
                      stateInfo={
                        this.state.stateInfo
                          ? {
                            key: this.state.stateInfo.id,
                            geojson: { ...this.state.stateInfo },
                          }
                          : null
                      }
                      sliderOptions={{
                        onClickSlideLeft: this.onClickSlideLeft,
                        onClickSlideRight: this.onClickSlideRight,
                        onSlide: this.onSlide,
                        slideTracker: this.state.slideTracker,
                        max: this.state.availableDates.length - 1,
                        date: moment(
                          this.state.availableDates[this.state.slideTracker],
                          "YYYYMMDD"
                        ).format("D MMM YYYY"),
                      }}
                      wms_url_base_layers={this.state.wms_url_base_layers}
                      studyarea={this.state.studyarea}
                      satellite={this.state.satellite}
                      year={this.state.year}

                      season={this.state.season}
                      cropyear={this.state.cropyear}
                      cropseason={this.state.cropseason}
                    // setSelectedMainMenu={this.setSelectedMainMenu}
                    // selectedMainMenu={this.state.selectedMainMenu}

                      viewport={this.state.viewport}
                      setViewport={this.setViewport}
                      cropmap = {'other'}

                      distributary_details={this.state.distributary_details}
                      distributary_details_visibility = {this.state.distributary_details_visibility}
                      handleMapClick={this.handleMapClick}

                      hist_cropseason={this.state.hist_cropseason}
                      selectedCommandArea={this.state.selectedCommandArea}

                      layers={this.state.layers}
                      url={this.state.url}
                      baselayerselected={this.state.baselayerselected}

                      changeBaseLayer={this.changeBaseLayer}

                      cropAreaLayer={this.state.cropAreaLayer}
                      cropAreaDate={this.state.cropAreaDate}
                      cwismLayer={this.state.cwismLayer}
                      cwismDate={this.state.cwismDate}
                      cropAreaName={this.state.commandAreaName}

                      handleDialogCloseD = {this.handleDialogCloseD}

                      selectedOpticalSensor ={this.state.selectedOpticalSensor}
                      selectedOpticalYear ={this.state.selectedOpticalYear}
                      selectedOpticalSeason ={this.state.selectedOpticalSeason}
                      
                      selectedMWSensor ={this.state.selectedMWSensor}
                      selectedMWYear ={this.state.selectedMWYear}
                      selectedMWSeason ={this.state.selectedMWSeason}
                      
                      selectedSatelliteLayer = {this.state.selectedSatelliteLayer}

                    />
                //   {/* </Grid.Column>

                //   <Divider vertical inverted/>

                //   <Grid.Column
                //     style={{
                //       width: "0%",
                //       height: "100%",
                //       //padding: "0px",
                //       //border: "0px",
                //     }}
                //   >
                //   <MapView
                //       handleSwipeChange={this.handleSwipeChange}
                //       swipevalue={this.state.swipevalue}
                //       arraycheck={this.state.arraycheck}
                //       legend_array_overlay={this.state.legend_array_overlay}
                //       basinoverlays={this.state.basinoverlays}
                //       legend={this.state.legend}
                //       setLatLng={this.setLatLng}
                //       markerPosition={[28.613, 77.209]}
                //       selected={this.state.selectedMenu}
                //       pointInfo={this.state.pointInfo}
                //       setLegend={this.setLegend}
                //       selectedLayer={this.state.selectedLayer}
                //       visibleLeft={this.state.visible}
                //       visibleGraphPanel={this.state.visibleGraphPanel}
                //       handleAnimationChange={this.handleAnimationChange}
                //       handleVisibleGraphPanelOnMapClick={
                //         this.handleVisibleGraphPanelOnMapClick
                //       }
                //       toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                //       getFeatureInfo={this.getFeatureInfo}
                //       setStateInfo={this.setStateInfo}
                //       // activeDate ={this.state.date}
                //       activeDate={
                //         moment.isMoment(this.state.date)
                //           ? this.state.date.format("DD MMMM YYYY")
                //           : moment(this.state.date, "DD-MM-YYYY").format(
                //             "DD MMMM YYYY"
                //           )
                //       }
                //       // setChartData={this.setChartData}
                //       // availableDates = {this.state.availableDates}
                //       // makeChartDataNDays={this.makeChartDataNDays}
                //       makeChartDataAvailableDays={this.makeChartDataAvailableDays}
                //       onClickDetails={{ ...this.state.onClickDetails }}
                //       setOnClickDetails={this.setOnClickDetails}
                //       stateInfo={
                //         this.state.stateInfo
                //           ? {
                //             key: this.state.stateInfo.id,
                //             geojson: { ...this.state.stateInfo },
                //           }
                //           : null
                //       }
                //       sliderOptions={{

                //         onClickSlideLeft: this.onClickSlideLeft,
                //         onClickSlideRight: this.onClickSlideRight,
                //         onSlide: this.onSlide,
                //         slideTracker: this.state.slideTracker,
                //         max: this.state.availableDates.length - 1,
                //         date: moment(
                //           this.state.availableDates[this.state.slideTracker],
                //           "YYYYMMDD"
                //         ).format("D MMM YYYY"),
                      
                //       }}
                //       wms_url_base_layers={this.state.wms_url_base_layers}
                //       studyarea={this.state.studyarea}
                //       satellite={this.state.satellite}
                //       year={this.state.year}

                //       season={this.state.season}
                //       cropyear={this.state.cropyear}
                //       cropseason={this.state.cropseason}
                //     // setSelectedMainMenu={this.setSelectedMainMenu}
                //     // selectedMainMenu={this.state.selectedMainMenu}

                //       viewport={this.state.viewport}
                //       setViewport={this.setViewport}
                //       cropmap = {'other'}

                //       distributary_details={this.state.distributary_details}
                //       distributary_details_visibility = {this.state.distributary_details_visibility}
                //       handleMapClick={this.handleMapClick}

                //       hist_cropseason={this.state.hist_cropseason}
                //     />

                //   </Grid.Column>
                // </Grid.Row> */}

                
                   
                // </Grid>
                  ) 
                }

                
              

            </Segment>

            {this.state.technicalnoteenable || this.state.disclaimerenable || this.state.IndexDiagramEnable ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.technicalnoteenable ?
                  <div id="divDialog" class="dialog boxshadow">
                    <div class="dialog_header">
                      <div
                        class="closebox"
                        onClick={this.handleDialogClose}
                      ></div>
                      Technical Note
                    </div>

                    <div
                      id="divDialog"
                      class="dialog boxshadow"
                      style={{ overflowY: "auto" }}
                    >
                      <div class="dialog_content">

                        <p ><span style={{ color: "blue" }}>Satellite Imagery</span></p>
                        <p align="justify"><span style={{ color: "blue" }}>Optical: </span></p>

                        <p align="justify">Standard False Colour Composite (FCC) of the multispectral data for better visualization of the vegetation </p>
                        <p align="justify"><span style={{ color: "blue" }}>Microwave: </span></p>

                        <p align="justify">Composite of VH-HH polarized C-Band microwave data is displayed, for visualization of vegetation during clouded condition. </p>
                        <p ><span style={{ color: "blue" }}>Satellite Data Derived Crop Map </span></p>
                        <p align="justify">The crop map displayed is derived from multispectral and microwave data, subjected to supervised classification  in conjunction with ground collected information
</p>
                        <p ><span style={{ color: "blue" }}>Crop Water Demand  </span></p>
                        <p align="justify">
                        The crop water demand (Crop Potential Evapotranspiration) for the prevalent meteorological condition is estimated for the existing crop considering the stage of the crop at a daily time step. The Reference Potential Evapotranspiration is estimated using Temperature based FAO Penman Montieth method
</p> <br /><br />
                      </div>

                    </div>
                  </div>


                  : this.state.disclaimerenable ? (
                    <div id="divDialog" class="dialog boxshadow">
                      <div class="dialog_header">
                        <div
                          class="closebox"
                          onClick={this.handleDialogDClose}
                        ></div>
                        Disclaimer
                    </div>
                      <div
                        id="divDialog"
                        class="dialog boxshadow"
                        style={{ overflowY: "auto" }}
                      >
                        <div class="dialog_content">
                          <ul style={{ textAlign: "justify" }}><li>
                            The satellite image displayed is representative of the season which has the maximum vegetation extend. The satellite images are acquired from the beginning to the end of the season for which inseason crop maps are derived through the season. </li>
                            <li>
                              The satellite image displayed is representative of the season which has the maximum vegetation extend. The satellite images are acquired from the beginning to the end of the season for which inseason crop maps are derived through the season, when multispectral data is not available due to clouded condition.
                      </li>
                            <li>
                              The crop map is generation and validation is done with respect to the limited ground data collected in conjunction with the satellite information. The accuracy of the crop map is subjective and is dependent on the reliability of the ground information. </li>
                            <li>
                            In the absence of AWS data in the study area coarse resolution gridded meteorological data is used in Crop Water Demand estimation.   </li></ul>
                          <br />
                          <br />

                        </div>

                      </div>
                    </div>
                  ) : this.state.IndexDiagramEnable ? (
                    <div id="divDialog" class="dialog boxshadow">
                      <div class="dialog_header">
                        <div
                          class="closebox"
                          onClick={this.handleDialogIClose}
                        ></div>
                        Index Diagram
                    </div>
                      <div
                        id="divDialog"
                        class="dialog boxshadow"
                        style={{ overflowY: "auto" }}
                      >
                        <div class="dialog_content">
                          <img style={{height: '100%', width: '100%'}} src={IndexDiagram} alt='Index Diagram' />
                          <br />
                          <br />

                        </div>

                      </div>
                    </div>
                  ): (
                      <div className="sweet-loading">
                        <FadeLoader
                          sizeUnit={"px"}
                          color={"#123abc"}
                          loading={this.state.chartloading}
                        />
                      </div>
                    )}
              </Rnd>
            ) : null}

            {/* {this.state.visibleGraphPanel ? (
              <Rnd
                style={{ zIndex: "200", background: "white" }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                {this.state.chartData !== null ? (
                  <Chart
                    {...this.state.chartData}
                    toggleVisibleGraphPanel={this.toggleVisibleGraphPanel}
                  />
                ) : (
                    <div className="sweet-loading">
                      <FadeLoader
                        sizeUnit={"px"}
                        color={"#123abc"}
                        loading={this.state.chartloading}
                      />
                    </div>
                  )}
              </Rnd>
            ) : null} */}

            {this.state.visibleGraphPanel ? (
              <Rnd
                style={{ zIndex: "1000", background: "white", overflowY: 'auto' }}
                size={{ width: this.state.width, height: this.state.height }}
                position={{ x: this.state.x, y: this.state.y }}
                onDragStop={(e, d) => {
                  this.setState({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, position) => {
                  this.setState({
                    width: ref.style.width,
                    height: ref.style.height,
                    ...position,
                  });
                }}
              >
                <div style={{textAlign: 'right', cursor: 'pointer'}}><Icon name="close" onClick={this.toggleVisibleGraphPanel} /></div>


                {(this.state.selectedMenu === 'Historical Season-Crop Map Historic' && this.state.caHistStats.length !== 0) ? (
                  // <div>
                  //   <div style={{textAlign: 'center'}}> <b>Crop Map Information</b> </div>
                  // <br/>Command Area : Narayanpur Irrigation System   
                  // <br/>Area of the Crop (ha): 319212.9772
                  // <br/>Paddy : 79137.91913 ha
                  // <br/>Irrigated Dry : 58777.86166 ha
                  // <br/>Biseasonal : 159068.3786 ha
                  // <br/>Perinnial : 22228.81782 ha
                  // </div>

                  <div style={{padding: '5px'}}>
                    

                    <table>
                      <tr>
                        <th colspan="2"><b style={{fontSize: '14px'}}>Seasonal Crop Area Information</b></th>
                      </tr>
                      <tr>
                        <td colspan="2">Season: <b>{`${this.state.caHistStats[0].season} (${this.state.hist_selectedyear})`}</b> </td>
                      </tr>
                      <tr>
                        <td colspan="2">Command Area: <b>{`${this.state.caHistStats[0].basin_name} (${this.state.caHistStats[0].basin})`}</b></td>
                      </tr>
                      <tr>
                        <td>Crop Name</td>
                        <td>Area (ha)</td>
                      </tr>
                      
                      <tr>
                        <td>Paddy</td>
                        <td>{`${this.state.caHistStats[0].paddy} ha`}</td>
                      </tr>
                      <tr>
                        <td>Irrigated Dry</td>
                        <td>{`${this.state.caHistStats[0].irridated_dry} ha`}</td>
                      </tr>
                      <tr>
                        <td>Biseasonal</td>
                        <td>{`${this.state.caHistStats[0].biseasonal} ha`}</td>
                      </tr>
                      <tr>
                        <td>Perinnial</td>
                        <td>{`${this.state.caHistStats[0].perinnial} ha`}</td>
                      </tr>
                      <tr>
                        <td>Total Area</td>
                        <td>{`${this.state.caHistStats[0].total} ha`}</td>
                      </tr>
                    </table>

                  </div>


                ) : (this.state.selectedMenu === 'Historical Season-Irrigation Requirement') ? (
                  <>
                    <div style={{textAlign: 'center'}}>
                    <b> Monthly and Seasonal Irrigation Requirement for {`${this.state.girHistStats.basin_name} (${this.state.girHistStats.basin})`} (in TMC) </b>
                    <br />
                    <b>Season : {`${this.state.girHistStats.season} (${this.state.hist_selectedyear})`}</b>
                    <br />
                    </div>
                    




                  <FIRColumnChart 
                      cap_stats_date={this.state.girHistStats.month}
                      cap_stats_paddy={this.state.girHistStats.data}
                    />
                  </>
                  
                ) : (this.state.selectedMenu === 'Historical Season-Irrigation System Performance') ? (
                  <>

                  <div style={{textAlign: 'center'}}>
                    <b> Irrigation System Performance for {`${this.state.cwsiHistStats1.basin_name} (${this.state.cwsiHistStats1.basin})`} </b>
                    <br />
                    <b>Season : {`${this.state.cwsiHistStats1.season} (${this.state.hist_selectedyear})`}</b>
                    <br />
                    </div>


                  <PieChart
                      series={this.state.cwsiHistStats}
                      menu={this.state.selectedMenu}
                      pie_categories={this.state.cwsi_pie_categories}
                    />

                  </>
                ) : (
                    <div className="sweet-loading">
                      <FadeLoader
                        sizeUnit={"px"}
                        color={"#123abc"}
                        loading={this.state.chartloading}
                      />
                    </div>
                  )}
              </Rnd>
            ) : null}



          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

export default MapContainer;
